// extracted by mini-css-extract-plugin
export var checkbox = "_6k-0";
export var circle = "_6k-3";
export var horizontalContainer = "_6k-7";
export var sm = "_6k-5";
export var switch0 = "_6k-2";
export var switchDisabled = "_6k-8";
export var switchEnabled = "_6k-1";
export var textSwitchContainer = "_6k-9";
export var textSwitchOption = "_6k-a";
export var textSwitchOptionSelected = "_6k-b";
export var verticalContainer = "_6k-6";
export var xs = "_6k-4";